<template>
	<CDialog
		:visible="isVisible"
		custom-class="dialog--tiny archive-folder-dialog"
		:title="title"
		@closed="$emit('closed')"
	>
		The folder and all forms in this folder will be archived. Archived forms will no longer be accessible. Are you sure you want to archive?
		<template #footer>
			<button class="button button--primary" @click="archiveClicked">
				Archive
			</button>
		</template>
	</CDialog>
</template>

<script lang="ts">
	import { computed, defineComponent, ref, watch } from 'vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';

	export default defineComponent({
		name: 'CArchiveFolderDialog',
		components: {
			CDialog
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			folderName: {
				type: String,
				required: true
			}
		},
		emits: [ 'confirm-archive', 'closed' ],
		setup(props, { emit }) {
			const isVisible = ref(props.show);

			const title = computed(() => `Archive ${props.folderName}?`);

			watch(() => props.show, () => (isVisible.value = props.show));

			const archiveClicked = () => {
				isVisible.value = false;
				emit('confirm-archive');
			};

			return {
				isVisible,
				title,
				archiveClicked
			};
		}
	});
</script>